// シートが見つからない時の誘導画面。
// drive.file スコープでは「つばめが作成・選択したファイル」だけ可視なので、
// シート不在 = iOS 版で 1 枚もスキャンしていない or 別アカウントでスキャン済の可能性。

interface Props {
  onRetry: () => void;
}

export default function NoSheetGuide({ onRetry }: Props) {
  return (
    <div className="mx-auto max-w-2xl px-6 py-16 text-center">
      <h2 className="serif text-2xl font-medium text-navy">
        まずは iOS 版で 1 枚スキャンしてください
      </h2>

      <p className="mt-6 text-sm leading-relaxed text-navySoft">
        Web 版は iOS 版でスキャン済の名刺シートを読み込んで表示します。
        <br />
        iOS 版で名刺を撮影すると、自動でスプレッドシートが作成され、
        <br />
        次回ログイン時に自動で検出されます。
      </p>

      <div className="mt-10 flex flex-col items-center gap-3">
        <a
          href="https://tsubamecard.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-primary"
        >
          App Store で iOS 版を見る
        </a>
        <button type="button" onClick={onRetry} className="btn-secondary">
          再検索する
        </button>
      </div>

      <details className="mt-12 text-left text-xs text-inkLight">
        <summary className="cursor-pointer font-medium text-navySoft">
          シートはあるはずなのに見つからない場合
        </summary>
        <div className="mt-3 space-y-2 leading-relaxed">
          <p>
            ・iOS 版で別の Google アカウントを使っていませんか?
            <br />
            同じアカウントでログインすると検出されます。
          </p>
          <p>
            ・シート名を「つばめカード」から変更していませんか?
            <br />
            元の名前に戻すと自動検出されます。
          </p>
          <p>
            ・シートがゴミ箱に入っていませんか?
            <br />
            復元すると検出されます。
          </p>
          <p>
            それでも解決しない場合は{" "}
            <a
              href="mailto:support@tsubamecard.com"
              className="underline hover:text-navy"
            >
              support@tsubamecard.com
            </a>{" "}
            までご連絡ください。
          </p>
        </div>
      </details>
    </div>
  );
}
